/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-c445dc73.js';
import { _ as _slicedToArray } from '../_chunks/dep-fc32874d.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { Icon } from 'tdesign-icons-react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { Overlay } from '../overlay/index.js';
import useMessageCssTransition from './hooks/useMessageCssTransition.js';
import useConfig from '../_util/useConfig.js';
import { IconType } from './constant.js';
import '../_chunks/dep-5cf1fbb1.js';
import '../_chunks/dep-f771ed13.js';
import '../_chunks/dep-b3e4e8ba.js';
import '../overlay/Overlay.js';
import 'ahooks';
import '../_chunks/dep-d5ec015e.js';
import '../_chunks/dep-b31bb48b.js';
import '../_chunks/dep-ba137374.js';
import '../_chunks/dep-6b86f47a.js';
import '../_chunks/dep-9fe8d051.js';
import 'react-dom';
import '../_util/withNativeProps.js';
import '../_chunks/dep-dadffb76.js';
import '../_chunks/dep-674c58f4.js';
import '../_chunks/dep-95834911.js';
import '../_chunks/dep-0e9724f2.js';
import '../_chunks/dep-cd7df551.js';
import '../_chunks/dep-41e2f4ed.js';
import '../_chunks/dep-818f0859.js';
import '../_chunks/dep-a4df350d.js';
import '../_chunks/dep-00b2fb56.js';
import '../_chunks/dep-6b8f1e75.js';
import '../_chunks/dep-aea8138c.js';
import '../_chunks/dep-d8b4285c.js';
import '../_util/withStopPropagation.js';
import '../_util/renderToContainer.js';
import '../_util/getContainer.js';
import '../_chunks/dep-3fecfff7.js';
import '../_util/canUseDom.js';
import '../_chunks/dep-c9dcffa1.js';
import '../_util/useLockScroll.js';
import '../_util/useTouch.js';
import '../_util/getScrollParent.js';
import '../_util/supportsPassive.js';
import '../_util/useShouldRender.js';
import '../_util/useInitialized.js';
import '../config-provider/ConfigContext.js';
import './style/css.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Toast = function Toast(props) {
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? "row" : _props$direction,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? "middle" : _props$placement,
    icon = props.icon,
    message = props.message,
    duration = props.duration,
    theme = props.theme,
    preventScrollThrough = props.preventScrollThrough,
    el = props.el;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var cls = "".concat(classPrefix, "-overflow-hidden");
  var TIcon = icon || theme && /* @__PURE__ */React__default.createElement(Icon, {
    className: "".concat(classPrefix, "-icon"),
    name: IconType[theme]
  });
  var containerClass = ["".concat(classPrefix, "-toast--").concat(direction || "row"), "".concat(classPrefix, "-toast--").concat(placement), icon && !message && "".concat(classPrefix, "-toast--icononly")];
  var contentRef = useRef(null);
  var cssTransitionState = useMessageCssTransition({
    contentRef: contentRef,
    classPrefix: classPrefix,
    el: el
  });
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    toastVisible = _useState2[0],
    setToastVisible = _useState2[1];
  useEffect(function () {
    var timer = null;
    if (duration) {
      timer = setTimeout(function () {
        setToastVisible(false);
      }, duration);
    }
    return function () {
      clearTimeout(timer);
    };
  }, [duration]);
  useEffect(function () {
    preventScrollThrough && document.body.classList.add(cls);
    return function () {
      preventScrollThrough && document.body.classList.remove(cls);
    };
  }, [preventScrollThrough, cls]);
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, preventScrollThrough && /* @__PURE__ */React__default.createElement(Overlay, null), /* @__PURE__ */React__default.createElement(CSSTransition, _objectSpread(_objectSpread({
    "in": toastVisible,
    appear: true
  }, cssTransitionState.props), {}, {
    unmountOnExit: true
  }), /* @__PURE__ */React__default.createElement("div", {
    className: classNames("".concat(classPrefix, "-toast"), [].concat(containerClass)),
    ref: contentRef
  }, TIcon && TIcon, message && /* @__PURE__ */React__default.createElement("div", {
    className: classNames("".concat(classPrefix, "-toast__text"))
  }, message))));
};

export { Toast as default };
//# sourceMappingURL=Toast.js.map
